import { RouteDefinition } from "./types";

import {publicroutes} from "./publicroutes";
import {privateroutes} from "./privateroutes";
import {lazy} from "react";

//error page
const Error404 = lazy(() => import('../pages/Errors/Error404'));

export const routes: RouteDefinition[] = [

    ...publicroutes,
    ...privateroutes,
    {
        component: Error404,
        exact: true,
        name: '404',
        path: '*',
        access: false
    }
];

